import { Usps } from "@omni/components/components/Blocks/usps/usps";
import { cn } from "@omni/utils/styles";

export const UspsComponent = () => {
    return (
        <Usps.Usp>
            <Usps.Usp.Content
                className={cn(
                    "tw:no-underline tw:flex tw:items-center tw:gap-2 tw:text-black"
                )}
            >
                <Usps.Usp.Icon className={cn("tw:text-success")} />
                <Usps.Usp.Text className={cn("tw:m-0 tw:font-bold")} />
            </Usps.Usp.Content>
        </Usps.Usp>
    );
};
